
import { useSelector } from 'react-redux'


const whiteList = ['matthew.cross@tfs.co.nz', 'kim.milne@tfs.co.nz']
const whiteListForUserAddition = ['matthew.cross@tfs.co.nz']

const isEmailInList = (email, list) => list.includes(email.toLowerCase())

export const useIsWhiteListed = () => {
  let userEmail = useSelector(({ account }) => account.profile?.email)
  return userEmail && (isEmailInList(userEmail, whiteList) || isBornUser(userEmail))
}

// function for validating is born super admin user
export const useIsBornAccount = () => {
  let userEmail = useSelector(({ account }) => account.profile?.email)
  return userEmail && isBornUser(userEmail)
}

// Check if user is a born user
export const isBornUser = (email) => {
  return email.toLowerCase().includes('borndigital.co.nz')
}

// Check if user is a TFS user
export const useIsUserATfs = () => {
  let userEmail = useSelector(({ account }) => account.profile?.email)
  return userEmail.toLowerCase().includes('tfs.co.nz')
}

// Check if user is a whitelisted user
export const isWhiteListed = (email) => email && (isEmailInList(email, whiteList) || isBornUser(email))

// function for returning current user role
export const useCurrentRole = () => useSelector(({ settings }) => settings?.roles)

// Only TFS whitleisted user
export const useIsWhiteListedTfs = () => {
  let userEmail = useSelector(({ account }) => account.profile?.email)
  return userEmail && isEmailInList(userEmail, whiteList)
}

// All TFS and Born User
export const useTfsBornUser = () => {
  let userEmail = useSelector(({ account }) => account.profile?.email)
  return userEmail && (userEmail.toLowerCase().includes('tfs.co.nz') || isBornUser(userEmail))
}

// Check if user is a tfs user and exception to Matthew Cross
export const isTfsUserAddition = (email) => {
  return email.toLowerCase().includes('tfs.co.nz') && !whiteListForUserAddition.includes(email.toLowerCase())
}
